import { Navigate, useLocation } from "react-router-dom";
import { getAuthRedirectTo } from "../stores/authStore";
import { Constants } from "../utils";

export default function UnauthenticatedRedirect() {
  const location = useLocation();
  return (
    <Navigate
      replace
      to={Constants.RoutePath.Login}
      state={{ redirectTo: getAuthRedirectTo(location) }}
    />
  );
}
